export function isoWeek(dateStr: string): number {
  const d = new Date(dateStr);
  // Use UTC date parts — lesson timestamps are stored as wall-clock (no tz).
  const jan4 = Date.UTC(d.getUTCFullYear(), 0, 4);
  const startOfWeek1 = jan4 - ((new Date(jan4).getUTCDay() || 7) - 1) * 86400000;
  return Math.ceil((d.getTime() - startOfWeek1) / (7 * 86400000)) + 1;
}

export function fmtDate(iso: string): string {
  // Timestamps are wall-clock Berlin time stored without tz; parse as local.
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function fmtRange(start: string, end: string): string {
  const s = new Date(start);
  const e = new Date(end);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(s.getHours())}:${p(s.getMinutes())}–${p(e.getHours())}:${p(e.getMinutes())}`;
}

export function CheckIcon({ className = "w-4 h-4 text-emerald-600 mx-auto" }: { className?: string }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );
}

export function XIcon({ className = "w-4 h-4 text-red-600 mx-auto" }: { className?: string }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

export function BookArrowIcon({ className = "w-4 h-4 text-slate-500" }: { className?: string }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v14H6.5A2.5 2.5 0 0 0 4 20.5V5.5Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h13" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 10h8m0 0-2.5-2.5M18 10l-2.5 2.5" />
    </svg>
  );
}
